<template>
  <div>
    <el-form ref="queryForm2" :model="queryParams" :inline="true">
      <el-form-item label="开始日期" prop="startDate">
        <el-date-picker
          v-model="queryParams.startDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery2(0)"
        />
      </el-form-item>
      <el-form-item label="结束日期" prop="endDate">
        <el-date-picker
          v-model="queryParams.endDate"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          @keyup.enter.native="handleQuery2(0)"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" :loading="loading" size="mini" @click="handleQuery2(0)">查询</el-button>
        <el-button icon="el-icon-download" size="mini" :loading="loading" @click="handleQuery2(1)">导出</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="date"
        label="日期"
        align="center"
        width="120"
      />
      <el-table-column
        v-for="(val, idx) in tableLen"
        :key="idx"
        :label="val"
        align="center"
      >
        <el-table-column
          label="用户数"
          align="center"
          width="120"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[idx].user }}
          </template>
        </el-table-column>

        <el-table-column
          label="支付用户数"
          align="center"
          width="120"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[idx].pay }}
          </template>
        </el-table-column>

        <el-table-column
          label="付费渗透率"
          align="center"
          width="120"
        >
          <template v-slot:default="scope">
            {{ scope.row.data[idx].permeability }}%
          </template>
        </el-table-column>
      </el-table-column>

    </el-table>
  </div>
</template>

<script>
import { getUserPayPermeability } from '@/api/statistics/user_remain'
import { getLastDates } from '@/utils'

export default {
  name: 'UserPayPermeability',
  data() {
    return {
      tableLen: [],
      dateArr: [],
      tableData: [],
      coinTotal: 0,
      levelData: [],
      queryParams: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        type: 0
      }
    }
  },
  created() {
    if (!this.queryParams.startDate) {
      this.queryParams.startDate = getLastDates(7)
    }

    if (!this.queryParams.endDate) {
      this.queryParams.endDate = getLastDates(1)
    }
    this.getTables()
  },
  methods: {
    handleQuery2(isExport = 0) {
      if (this.queryParams.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams.startDate > this.queryParams.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      this.getTables(isExport)
    },
    getTables(isExport) {
      this.loading = true
      this.queryParams.type = 0
      if (isExport) {
        this.queryParams.type = 1
      }
      getUserPayPermeability(this.queryParams).then(res => {
        this.loading = false
        if (res.code === 200) {
          if (this.queryParams.type === 1) {
            window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          }
          if (res.data.data.length > 0) {
            res.data.data[0].data.forEach((item) => {
              this.tableLen.push(item.start + '-' + item.end)
            })
          }
          this.tableData = res.data.data
        } else {
          this.msgError(res.msg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
